@if (cartProductCount > 0) {
  <button
    type="button"
    mat-icon-button
    [attr.matTooltip]="'globalUi.cart' | translate"
    (click)="goToCartCheckout()"
    >
    <img alt="" src="assets/icons/shopping_cart-24px.svg" class="shopping_cart-24px" />
  </button>
} @else {
  <button mat-icon-button (click)="goToCartCheckout()">
    <img alt=""
      src="../../../assets/icons/header-cart_icon.svg"
      width="22px"
      height="22px"
      />
  </button>
}
<p
  class="total-cart"
  [ngStyle]="{ opacity: cartProductCount > 0 ? 1 : 0 }"
  (click)="goToCartCheckout()"
  >
</p>
